(function () {
  var SAFFRON = '#C97B1A';
  var EMPTY   = 'rgba(240,235,225,0.07)';

  function applyHistogramColors() {
    var rows = document.querySelectorAll('.jdgm-histogram__row');
    if (!rows.length) return false;

    rows.forEach(function (row) {
      // Read the review count for this star tier
      var countEl = row.querySelector('.jdgm-histogram__count');
      var count   = countEl ? parseInt(countEl.textContent.trim(), 10) : 0;

      // Find every element in the row that carries a width (the fill bar)
      var allEls = row.querySelectorAll('[style*="width"]');

      if (allEls.length) {
        // Use width-based approach: the element with width > 0 is the fill
        allEls.forEach(function (el) {
          var w = parseFloat(el.style.width) || 0;
          el.style.setProperty('background', w > 0 ? SAFFRON : EMPTY, 'important');
          el.style.setProperty('min-width',  '0',                      'important');
          el.setAttribute('data-jdgm-active', w > 0 ? 'true' : 'false');
        });
      } else {
        // Fallback: colour all bar-like elements by count
        var barEls = row.querySelectorAll('[class*="histogram__bar"]');
        barEls.forEach(function (el) {
          el.style.setProperty('background', count > 0 ? SAFFRON : EMPTY, 'important');
          el.setAttribute('data-jdgm-active', count > 0 ? 'true' : 'false');
        });
      }
    });

    return true;
  }

  function tryApply() {
    if (applyHistogramColors()) return;
    // Histogram not rendered yet — watch for it
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function () {
      if (applyHistogramColors()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryApply);
  } else {
    tryApply();
  }

  // Re-run after pagination loads new reviews
  document.addEventListener('jdgm:load:end',   tryApply);
  document.addEventListener('jdgm:ajax:end',   tryApply);
  document.addEventListener('jdgm:filter:end', tryApply);
})();
